import { Label } from './Label'
import type { LabelProps } from './Label'

import type { components } from '../../constants/schema'

interface ProductLabelProps extends LabelProps {
  type?: components['schemas']['ProductDto']['overallStatus'] | components['schemas']['UserProductDto']['status']
  label?:
    | components['schemas']['ProductDto']['overallStatusLabel']
    | components['schemas']['UserProductDto']['statusLabel']
}

export function ProductLabel(props: ProductLabelProps) {
  const { type, label } = props

  const colorFromType: () => Pick<LabelProps, 'backgroundColor' | 'textColor' | 'children'> = () => {
    switch (type) {
      case 'SALE_TO_BE_RELEASED':
        return { backgroundColor: 'secondary_6', textColor: 'text_white', children: label ?? '청약 예정' }
      case 'SALE_RELEASE':
        return { backgroundColor: 'primary_5', textColor: 'text_white', children: label ?? '청약 중' }
      default:
        return { backgroundColor: 'gray_6', textColor: 'gray_3', children: '청약 마감' }
    }
  }

  const { backgroundColor, textColor, children } = colorFromType()

  return (
    <Label {...props} backgroundColor={backgroundColor} textColor={textColor}>
      {children}
    </Label>
  )
}
